import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';

const useStyles = makeStyles((theme)=>({
    label: {
        width: '100%'
    }
}));

export default function CustomRadioButtonGroup(props){
    const classes = useStyles();
    const {items, label, selected} = props;

    return (
        <FormControl component="fieldset" fullWidth>
            {label && <FormLabel component="legend">{label}</FormLabel>}
            <RadioGroup
                aria-label={label ? label : null}
                defaultValue={selected ? selected : null}
                name="radio-buttons-group"
                onChange={props.onChange}
            >
                {items && items.length > 0 && items.map((item, index) => {
                    return (
                        <Grid item xs={12} key={index}>
                            <FormControlLabel value={item.value} control={<Radio />} label={item.label} className={classes.label}/>                            
                            {selected == item.value && item.child ? item.child : null}
                        </Grid>
                    );
                })}
            </RadioGroup>
        </FormControl>
    );
}